import ButtonDesigned from '../../../../../../components/UI-Elements/Buttons/ButtonDesigned';

// The function will be re-written - when there will be more logic
export const ProductModifyAdvanced = () => {
  return (
    <div>
      <div className="flex flex-col gap-2">
        <h6 className="text-red text-lg">{'Advanced'}</h6>
        <div className="flex gap-3">
          <ButtonDesigned
            onButtonClick={() => {}}
            style="outline"
            roundedValue="2xl"
            className="px-3 py-2"
            disableButton={true}
          >
            <div className="flex gap-2">
              <img src="../assets/icons/blue-flat/price.svg"></img>
              Product Price
            </div>
          </ButtonDesigned>
          <ButtonDesigned
            onButtonClick={() => {}}
            style="outline"
            roundedValue="2xl"
            className="px-3 py-2"
            disableButton={true}
          >
            <div className="flex gap-2">
              <img src="../assets/icons/blue-flat/formulaIcon.svg"></img>
              Formula
            </div>
          </ButtonDesigned>
          <ButtonDesigned
            onButtonClick={() => {}}
            style="outline"
            roundedValue="2xl"
            className="px-3 py-2"
            disableButton={true}
          >
            <div className="flex gap-2">
              <img src="../assets/icons/blue-flat/material.svg"></img>
              Material type
            </div>
          </ButtonDesigned>
          <ButtonDesigned
            onButtonClick={() => {}}
            style="outline"
            roundedValue="2xl"
            className="px-3 py-2"
            disableButton={true}
          >
            <div className="flex gap-2">
              <img src="../assets/icons/blue-flat/orders.svg"></img>
              Suppliers
            </div>
          </ButtonDesigned>
          <ButtonDesigned
            onButtonClick={() => {}}
            style="outline"
            roundedValue="2xl"
            className="px-3 py-2"
            disableButton={true}
          >
            <div className="flex gap-2">
              <img src="../assets/icons/blue-flat/other.svg"></img>
              Other
            </div>
          </ButtonDesigned>
        </div>
      </div>
    </div>
  );
};
